module.exports = __webpack_public_path__ + "media/country_flags/es-8bb6862e.png";